import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-arrow-down',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()"
         [attr.height]="size()" viewBox="0 0 24 24">
      <path fill="currentColor" fill-rule="evenodd"
            d="M5.99977 8.25005 17.9998 8.25c.3033 0 .5768.18273.6929.46298.1161.28026.0519.60285-.1626.81735l-6
            5.99997c-.2928.2929-.7677.2929-1.0606 0L5.46944 9.53038c-.2145-.2145-.27867-.53708-.16258-.81734.11608-.28026.38956-.46299.69291-.46299Z"
            clip-rule="evenodd" />
    </svg>
  `
})
export class IconArrowDownComponent {
  size: InputSignal<number> = input<number>(24);
}
